export const actionModalSliceDispatch = {
    setOpen: "actionModal/setOpen",
    setActionToAdd: "actionModal/setActionToAdd"
}

export const appSliceDispatch = {
    setActiveTabIndex: "app/setActiveTabIndex"
}

export const brandModalSliceDispatch = {
    setOpen: "brandModal/setOpen",
    setBrandToAdd: "brandModal/setBrandToAdd"
}

export const brandViewerSliceDispatch = {
    setCurrentQuestion: "brandViewer/setCurrentQuestion",
    setAddModal: "brandViewer/setAddModal",
    setEditModal: "brandViewer/setEditModal"
}

export const conditionDetailEditorSliceDispatch = {
    setFact: "conditionDetailEditor/setFact",
    setOperator: "conditionDetailEditor/setOperator",
    setValue: "conditionDetailEditor/setValue"
}

export const layoutCategoryFieldModalSliceDispatch = {
    setOpen: "layoutCategoryFieldModal/setOpen",
    setLayoutToAdd: "layoutCategoryFieldModal/setLayoutToAdd"
}

export const layoutCategoryModalSliceDispatch = {
    setOpen: "layoutCategoryModal/setOpen",
    setLayoutToAdd: "layoutCategoryModal/setLayoutToAdd"
}

export const layoutViewerSliceDispatch = {
    setActiveLayoutCategoryIndex: "layoutViewer/setActiveLayoutCategoryIndex",
    setActiveLayoutTabIndex: "layoutViewer/setActiveLayoutTabIndex"
}

export const pickAFileSliceDispatch = {
    setFileContents: "pickAFile/setFileContents",
    setActions: "pickAFile/setActions",
    setAssistanceFormId: "pickAFile/setAssistanceFormId",
    setBaseName: "pickAFile/setBaseName",
    setFileLength: "pickAFile/setFileLength",
    setFormDescription: "pickAFile/setFormDescription",
    setFormName: "pickAFile/setFormName",
    setFormRuleSetId: "pickAFile/setFormRuleSetId",
    setInterfaceId: "pickAFile/setInterfaceId",
    setFileName: "pickAFile/setFileName",
    setAddressStart: "pickAFile/setAddressStart",
    setAddressEnd: "pickAFile/setAddressEnd",
    setRules: "pickAFile/setRules",
    setAutofill: "pickAFile/setAutofill",
    setMeta: "pickAFile/setMeta",
    setDetails: "pickAFile/setDetails",
    setQuestions: "pickAFile/setQuestions",
    setLayout: "pickAFile/setLayout",
    setServiceQuestions: "pickAFile/setServiceQuestions",
    setServiceBrandQuestions: "pickAFile/setServiceBrandQuestions",
    setBrandList: "pickAFile/setBrandList",
    setServiceList: "pickAFile/setServiceList",
    setSelectedServiceList: "pickAFile/setSelectedServiceList",
    setSelectedBrandList: "pickAFile/setSelectedBrandList",
    setFormContext: "pickAFile/setFormContext",
    setServiceDropDownList: "pickAFile/setServiceDropDownList",
    setBrandDropDownList: "pickAFile/setBrandDropDownList",
    setHasMultipleServices: "pickAFile/setHasMultipleServices",
    setHasMultipleBrands: "pickAFile/setHasMultipleBrands",
    setBusinessRules: "pickAFile/setBusinessRules",
    setFilePath: "pickAFile/setFilePath",
    setAnswers: "pickAFile/setAnswers"
}

export const questionModalSliceDispatch = {
    setOpen: "questionModal/setOpen",
    setQuestionToAdd: "questionModal/setQuestionToAdd",
    setPendingServices: "questionModal/setPendingServices"
}

export const questionOptionsModalSliceDispatch = {
    setOpen: "questionOptionsModal/setOpen",
    setValueToAdd: "questionOptionsModal/setValueToAdd",
    setOptionToAdd: "questionOptionsModal/setOptionToAdd",
    setAllOptions: "questionOptionsModal/setAllOptions"
}

export const questionViewerSliceDispatch = {
    setCurrentQuestion: "questionViewer/setCurrentQuestion",
    setAddModal: "questionViewer/setAddModal",
    setEditModal: "questionViewer/setEditModal",
    setIndexOverride: "questionViewer/setIndexOverride",
    setQuestionSearchResults: "questionViewer/setQuestionSearchResults"
}

export const refreshLoadedFileSliceDispatch = {
    setIsLoading: "refreshLoadedFile/setIsLoading"
}

export const ruleModalSliceDispatch = {
    setOpen: "ruleModal/setOpen",
    setRuleToAdd: "ruleModal/setRuleToAdd",
    setRuleToAddConditionsAll: "ruleModal/setRuleToAddConditionsAll",
    setRuleToAddConditionsAny: "ruleModal/setRuleToAddConditionsAny",
    setRuleToAddName: "ruleModal/setRuleToAddName",
    setRuleToAddEventType: "ruleModal/setRuleToAddEventType",
    setConditionDisabled: "ruleModal/setConditionDisabled",
    setIsAddingCondition: "ruleModal/setIsAddingCondition",
    setSelectedCondition: "ruleModal/setSelectedCondition"
}

export const serviceModalSliceDispatch = {
    setOpen: "serviceModal/setOpen",
    setServiceToAdd: "serviceModal/setServiceToAdd"
}

export const serviceQuestionBrandModalSliceDispatch = {
    setOpen: "serviceQuestionBrandModal/setOpen",
    serviceQuestionBrandToAdd: "serviceQuestionBrandModal/serviceQuestionBrandToAdd",
    setServiceId: "serviceQuestionBrandViewer/setServiceId",
    setBrandId: "serviceQuestionBrandViewer/setBrandId"
}

export const serviceQuestionModalSliceDispatch = {
    setOpen: "serviceQuestionModal/setOpen",
    setServiceQuestionsToAdd: "serviceQuestionModal/setServiceQuestionsToAdd",
    setQuestionsToShow: "serviceQuestionModal/setQuestionsToShow",
    setServiceId: "serviceQuestionModal/setServiceId"
}

export const serviceQuestionViewerSliceDispatch = {
    setActiveIndex: "serviceQuestionViewer/setActiveIndex"
}

export const questionServiceQuestionBrandModalSliceDispatch = {
    setOpen: "questionServiceQuestionBrandModal/setOpen",
    setPendingServiceBrandQuestions: "questionServiceQuestionBrandModal/setPendingServiceBrandQuestions",
    setSelectedBrand: "questionServiceQuestionBrandModal/setSelectedBrand",
    setSelectedService: "questionServiceQuestionBrandModal/setSelectedService"
}

export const reducerDispatch = {
    resetState: "reducer/resetState"
}

export const actionViewerSliceDispatch = {
    setCurrentAction: "actionViewer/setCurrentAction",
    setAddModal: "actionViewer/setAddModal",
    setEditModal: "actionViewer/setEditModal",
    setIndexOverride: "actionViewer/setIndexOverride",
    setActionSearchResults: "actionViewer/setActionSearchResults"
}

export const ruleViewerSliceDispatch = {
    setCurrentRule: "ruleViewer/setCurrentRule",
    setAddModal: "ruleViewer/setAddModal",
    setEditModal: "ruleViewer/setEditModal",
    setIndexOverride: "ruleViewer/setIndexOverride",
    setRuleSearchResults: "ruleViewer/setRuleSearchResults"
}

export const uploadFileSliceDispatch = {
    setApiResponse: "uploadFile/setApiResponse"
}

export const apiResponseModalSliceDispatch = {
    setOpen: "apiResponseModal/setOpen",
    setOpenedFileFromApi: "apiResponseModal/setOpenedFileFromApi"
}

export const selectFileSliceDispatch = {
    setSelectedFilesList: "selectedFile/setSelectedFilesList",
    setSelectedFileTemplate: "selectedFile/setSelectedFileTemplate",
    setOpen: "selectedFile/setOpen",
    setApiResponse: "selectedFile/setApiResponse",
    setApiSuccess: "selectedFile/setApiResponse",
    setIsTemplate: "selectedFile/setIsTemplate",
    setIsDataModel: "selectedFile/setIsDataModel"
}

export const serviceViewerSliceDispatch = {
    setCurrentService: "serviceViewer/setCurrentService",
    setAddModal: "serviceViewer/setAddModal",
    setEditModal: "serviceViewer/setEditModal",
    setIndexOverride: "serviceViewer/setIndexOverride"
}

export const standardQuestionSliceDispatch = {
    setQuestions: "standardQuestion/setQuestions",
    setModalOpen: "standardQuestion/setModalOpen",
    setIsAdd: "standardQuestion/setIsAdd",
    setSelectedQuestion: "standardQuestion/setSelectedQuestion",
    setDeleteModalOpen: "standardQuestion/setDeleteModalOpen",
    setSearchValue: "standardQuestion/setSearchValue",
    setCategories: "standardQuestion/setCategories",
    setSelectOpen: "standardQuestion/setSelectOpen",
    setSelectLayout: "standardQuestion/setSelectLayout"
}